import {Form, Input} from 'antd';

export function Title() {
    return (
        <Form.Item label={'Title'} name={'title'}>
            <Input id={'title'} placeholder={'e.g. Concert Tickets'}/>
        </Form.Item>
    )
}
